import { v4 as uuidv4 } from 'uuid'

export function generateUUID(): string {
  try {
    return window.crypto.randomUUID()
  } catch (_error) {
    return uuidv4()
  }
}
